import React, { FC, useEffect, useRef } from "react";
import { Accordion } from "react-bootstrap";
import QuicktipLobbyWidget from "./QuicktipLobbyWidget";
import QuickbetXLobbyWidget from "./QuickbetXLobbyWidget";
import JackpotLobbyWidget from "./JackpotLobbyWidget";
import SmartbetLobbyWidget from "./SmartbetLobbyWidget";
import QuickbetLobbyWidget from "./QuickbetLobbyWidget";
import SuperbetLobbyWidget from "./SuperbetLobbyWidget";
import './SidebarLobbyWidget.css';

const lobbyComponents: Record<number, React.FC<any>> = {
    1: QuicktipLobbyWidget,
    2: SmartbetLobbyWidget,
    3: SuperbetLobbyWidget,
    4: QuickbetLobbyWidget,
    5: JackpotLobbyWidget,
    6: QuickbetXLobbyWidget,
};

const defaultOrder = [1, 2, 3, 4, 5, 6];

interface SidebarLobbyWidget {
    atagParams: string | null,
    types?: number[] | null,
    defaultOpenType?: string | null,
    theme?: string | null,
    sourceParams: string | null,
    viewType: string | null,
    ticketOpenMode: string | null,
}

const SidebarLobbyWidget: FC<SidebarLobbyWidget> = ({
                                                        atagParams,
                                                        types,
                                                        theme,
                                                        ticketOpenMode,
                                                        defaultOpenType,
                                                        viewType,
                                                        sourceParams
                                                    }) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    const transformeddDfaultOpenType = defaultOpenType ? Number(defaultOpenType) : null;
    const ticketsToRender = types && types.length
        ? types
        : defaultOrder;

    const resolvedDefaultType = (() => {
        if (
            typeof transformeddDfaultOpenType === "number" &&
            ticketsToRender.includes(transformeddDfaultOpenType)
        ) {
            return transformeddDfaultOpenType;
        }

        return ticketsToRender[0];
    })();

    const defaultActiveKey = String(resolvedDefaultType);

    useEffect(() => {
        if (viewType === 'sidebar') {
            const sendHeight = () => {
                const height = document.body.scrollHeight;

                window.parent.postMessage(
                    {
                        type: "SET_LOBBY_SIDEBAR_WIDGET_HEIGHT",
                        height
                    },
                    "*"
                );
            };

            sendHeight();
            const observer = new ResizeObserver(() => {
                sendHeight();
            });

            observer.observe(document.body);

            return () => {
                observer.disconnect();
            };
        }
    }, [viewType]);

    useEffect(() => {
        if (ticketOpenMode !== "modal") return;

        const handleClickCapture = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            const link = target.closest("a");
            if (!link) return;

            if (!link.classList.contains("sidebar-ticket-link")) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            window.parent.postMessage(
                {
                    type: "OPEN_SIDEBAR_TICKET_MODAL",
                    url: (link as HTMLAnchorElement).href,
                    widgetId: 'lobbySidebarModalID'
                },
                "*"
            );
        };

        document.addEventListener("click", handleClickCapture, true);

        return () => {
            document.removeEventListener("click", handleClickCapture, true);
        };
    }, [ticketOpenMode]);

    return (
        <div className="Sidebar-widget" data-theme={theme}>
            <div className="betting-tips-card" ref={containerRef}>
                <div className="betting-tips-header">
                    <p className="betting-tips-title">Betting Tips</p>
                </div>

                <hr className="betting-tips-divider" />

                <Accordion
                    defaultActiveKey={defaultActiveKey}
                    flush
                    className="betting-tips-accordion"
                >
                    {ticketsToRender.map((type) => {
                        const Component = lobbyComponents[type];
                        if (!Component) return null;

                        return (
                            <Component
                                key={type}
                                eventKey={type.toString()}
                                atagParams={atagParams}
                                sourceParams={sourceParams}
                                viewType={viewType}
                                ticketOpenMode={ticketOpenMode}
                            />
                        );
                    })}
                </Accordion>
            </div>
        </div>
    );
};

export default SidebarLobbyWidget;